import { Box, Typography } from "@mui/material";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    LabelList,
    ReferenceArea
} from "recharts";

const data = [
    { year: 2008, value: -2.1 },
    { year: 2009, value: -1.8 },
    { year: 2010, value: -1.6 },
    { year: 2011, value: -1.4 },
    { year: 2012, value: -1.2 },
    { year: 2013, value: -1.0 },
    { year: 2014, value: -0.9 },
    { year: 2015, value: -0.8 },
    { year: 2016, value: -1.2 },
    { year: 2017, value: -1.1 },
    { year: 2018, value: -0.9 },
    { year: 2019, value: -0.8 },
    { year: 2020, value: -0.7 },
    { year: 2021, value: -0.6 },
    { year: 2022, value: -0.5 },
    { year: 2023, value: -1.4 },
    { year: 2024, value: -4.7 },
    { year: 2025, value: -4.5 }
];

const Tract3G3: React.FC = () => {
    return (
        <Box sx={{ position: "relative", height: 290 }}>
            {/* Graphique Recharts */}
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 40, right: 20, left: 20, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                    <XAxis dataKey="year" />
                    <YAxis domain={[-5, 0]} />
                    <Tooltip formatter={(v) => `${v} M€`} />

                    {/* Zone du maire actuel */}
                    <ReferenceArea
                        x1={2018}
                        x2={2025}
                        fill="#e5e0ff"
                        fillOpacity={0.9}
                    />

                    {/* Barres de dette (en négatif) */}
                    <Bar dataKey="value" fill="#c62828" radius={[4, 4, 0, 0]}>
                        <LabelList
                            dataKey="value"
                            position="bottom"
                            formatter={(value) =>
                                String(value).replace(".", ",")
                            }
                        />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>

            {/* Libellé "M. Dintilhac maire" */}
            <Box
                sx={{
                    position: "absolute",
                    top: 5,
                    left: "60%",
                    px: 1,
                    py: 0.3,
                    bgcolor: "transparent",
                    borderRadius: 1
                }}
            >
                <Typography
                    variant="caption"
                    sx={{ fontWeight: 600, fontStyle: "italic", color: "#444"}}
                >
                    M. Dintilhac maire
                </Typography>
            </Box>

            {/* Pastille rouge +371% */}
            <Box
                sx={{
                    position: "absolute",
                    top: 120,
                    left: "72%", // ajuste si besoin
                    px: 1.8,
                    py: 0.4,
                    bgcolor: "#b71c1c",
                    borderRadius: 999,
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 700
                }}
            >
                +371%
            </Box>

            {/* Pastille -51% (2008–2013) */}
            <Box
                sx={{
                    position: "absolute",
                    top: 120,
                    left: "22%", // centré entre 2008 et 2013
                    px: 1.8,
                    py: 0.3,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    border: "1px solid #555",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#444"
                }}
            >
                -51%
            </Box>

            {/* Pastille +20% (2014–2017) */}
            <Box
                sx={{
                    position: "absolute",
                    top: 120,
                    left: "45%", // centré entre 2014 et 2017
                    px: 1.8,
                    py: 0.3,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    border: "1px solid #555",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#444"
                }}
            >
                +20%
            </Box>
        </Box>
    );
};

export default Tract3G3;
